// src/pages/PrivacyPolicyPage.js (CÓDIGO CORREGIDO PARA REACT ROUTER)

import React from 'react';
import { useNavigate } from 'react-router-dom'; // ✅ Importamos useNavigate
// 🛑 RUTA DE IMPORTACIÓN CORRECTA
import PrivacyPolicyContent from '../components/PrivacyPolicyContent'; 

// ✅ Eliminamos { setActivePage } de las props
const PrivacyPolicyPage = () => { 
    const navigate = useNavigate(); // ✅ Inicializamos el hook de navegación

    return (
        // Usar la clase general 'page-container' y estilos CSS si existen
        <div className="page-container" style={{ paddingTop: '80px', minHeight: '80vh' }}>
            
            <PrivacyPolicyContent />
            
            <button 
                // ✅ CORRECCIÓN CLAVE: Usamos navigate('/') en lugar de setActivePage
                onClick={() => navigate('/')} 
                style={{ 
                    margin: '40px auto', 
                    display: 'block', 
                    padding: '12px 25px',
                    backgroundColor: 'var(--color-dorado, #e6b800)',
                    color: 'var(--color-negro, #000033)',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer'
                }}
            >
                Volver al Inicio
            </button>
        </div>
    );
};

export default PrivacyPolicyPage;